import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';

export const getUrlSearchParams = (param, queryString) => {
  const searchParam = new RegExp('[?&]' + param + '=([^&#]*)').exec(queryString);
  return searchParam && decodeURI(searchParam[1]);
};

export const shouldDisplayReferrerRecommendations = (referer) => {
  const url = typeof window !== 'undefined' && window.location?.href;
  return /google.com|bing.com|yahoo.com|duckduckgo.com|aol.com/i.test(referer)
    || /^Shopping/i.test(getUrlSearchParams('cm_mmc', url))
    || /PIN_Shopping/i.test(getUrlSearchParams('cm_mmc', url));
};

export const shouldDisplayPipInStock = (data = {}, referer) => {
  const { product = {} } = data || {};
  if (shouldDisplayReferrerRecommendations(referer)) {
    return false;
  }
  if (podFulFillmentUtils.isDiscontinued(product)) {
    return true;
  }
  if (product?.availabilityType?.type === 'Browse Only') {
    return podFulFillmentUtils.isOutOfStockYourStore(product);
  }
  if (product?.availabilityType?.type === 'Online') {
    return podFulFillmentUtils.isOutOfStockOnline(product);
  }
  if (product?.availabilityType?.type === 'Shared') {
    return !!(podFulFillmentUtils.isOutOfStockOnline(product)
      || podFulFillmentUtils.isOutOfStockShared(product)
      || podFulFillmentUtils.isLimitedStock(product)
      || podFulFillmentUtils.isBackordered(product)
      || !podFulFillmentUtils.isATCEnabled(product));
  }
  if (product?.availabilityType?.type === 'Store Only') {
    return podFulFillmentUtils.isBuyInStore(product);
  }
  return false;
};

export const shouldDisplayPipAlternativeRecs = (data = {}, referer) => {
  return !shouldDisplayReferrerRecommendations(referer) && !shouldDisplayPipInStock(data, referer);
};

export const shouldDisplayBatterySystems = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.batItems;
};

export const shouldDisplayPipCollections = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.pipCollections;
};

export const shouldDisplayVisuallySimilar = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.visualNavigation;
};

export const shouldDisplayIrgaccessories = (hideYMAN, data = {}) => {
  return (!hideYMAN && data?.product?.info?.recommendationFlags?.ACC);
};

export const shouldDisplayBBRCollections = (data = {}) => {
  return data?.product?.info?.recommendationFlags?.collections;
};

export const shouldDisplayIrgcollections = (data = {}) => {
  return (shouldDisplayBBRCollections(data) && !shouldDisplayPipCollections(data))
  && !shouldDisplayBatterySystems(data);
};

const isDiscontinued = (product) => {
  return !!(product?.availabilityType?.discontinued);
};

const getNearByStore = (fulfillment) => {
  const locations = fulfillment?.locations || [];
  if (locations.length > 1) {
    const nearbyStore = locations.find((location) => !location.isAnchor);
    return nearbyStore;
  }
  return null;
};
const getLocalStore = (fulfillment) => {
  const locations = fulfillment?.locations || [];
  const localStore = locations.find((location) => location.isAnchor);
  return localStore;
};

const isBOPISHaveQuantity = (product) => {
  const pickupService = (product?.fulfillment?.fulfillmentOptions || []).find((option) => option.type === 'pickup');
  const bopisFulfillment = (pickupService?.services || []).find((service) => service.type === 'bopis');
  if (!bopisFulfillment) {
    return false;
  }
  const nearByStoreLocation = getNearByStore(bopisFulfillment);
  const localStoreLocation = getLocalStore(bopisFulfillment);
  return pickupService?.fulfillable
    && (localStoreLocation?.inventory?.quantity > 0 || nearByStoreLocation?.inventory?.quantity > 0);
};

export const isLightingCategory = (data = {}) => {
  return (data?.product?.taxonomy?.breadCrumbs?.[0]?.label.toLowerCase() === 'lighting');
};

const removeTypenameDeep = (input) => {
  if (Array.isArray(input)) {
    return input.map(removeTypenameDeep);
  }
  if (input && typeof input === 'object') {
    const { __typename, ...rest } = input;
    return Object.fromEntries(
      Object.keys(rest).map((key) => [key, removeTypenameDeep(rest[key])])
    );
  }
  return input;
};

export const getProductTaxonomy = (data = {}) => {
  if (!data?.product?.taxonomy) {
    return null;
  }
  return { taxonomy: removeTypenameDeep(data.product.taxonomy) };
};

// Main function to determine BBT display logic
export const getBBTDisplayPosition = (hideFBT, hideYMAN, data = {}) => {
  const recommendationFlags = data?.product?.info?.recommendationFlags || {};
  const hasBundleOrPackages = Boolean(recommendationFlags.bundles || recommendationFlags.packages);

  // If hideFBT and hideYMAN are true and no bundle/packages -> display above
  if (hideFBT && !hasBundleOrPackages) {
    return 'above';
  }

  // If hideYMAN is true and bundle/packages exist -> display below
  if (hideYMAN && (hasBundleOrPackages || !hideFBT)) {
    return 'below';
  }

  return 'none';
};

export const shouldDisplayBBTAbove = (hideFBT, hideYMAN, data = {}) => {
  return getBBTDisplayPosition(hideFBT, hideYMAN, data) === 'above';
};

export const shouldDisplayBBTBelow = (hideFBT, hideYMAN, data = {}) => {
  return getBBTDisplayPosition(hideFBT, hideYMAN, data) === 'below';
};